var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"text-h5 blueMain--text",domProps:{"textContent":_vm._s(_vm.$props.title)}}),_c('v-card-text',{attrs:{"id":"article_text"},domProps:{"innerHTML":_vm._s(_vm.$props.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }